import { _MSGTYPES } from './msgType';

/**
 * 常量
 */
const isMock = false;
const apiPrefix = isMock ? '' : 'icc/service';

export function genUrl(url, name?) {
  return { url: apiPrefix + url, name };
}
export const appInfo = {
  name: '应急事件',
  title: '融合消息管理系统',
};

export const URLS = {
  login: genUrl('/login', '登录'),
  logout: genUrl('/logout/', '登出'),
  registry: genUrl('/registry', '注册'),
  loginCaptcha: genUrl('/loginCaptcha', '获取登录验证码'),
  checkReportToken: genUrl('/common/verifyReportAuthToken', '获取校验码'),
  // #home
  menu: genUrl('/home/menu', '菜单'),
  sendRecordList: genUrl('/msgRecord/sendRecord/topList', '首页Top3发送记录'),
  checkPwdCycle: genUrl('/checkPwdCycle', '检查登录周期'),
  wechatPreview: genUrl('/common/bizType/wechatPreview', '微信预发送'),
  user: genUrl('/system/user/list', '用户列表'),
  userRoles: genUrl('/system/user/roles', '用户角色'),
  bizs: genUrl('/system/user/bizs', '用户业务类型'),
  departments: genUrl('/system/user/department/list', '部门列表'),
  departmentAdd: genUrl('/system/user/department/add', '部门新增'),
  departmentEdit: genUrl('/system/user/department/edit', '部门编辑'),
  departmentDelete: genUrl('/system/user/department/delete', '部门删除'),
  userView: genUrl('/system/user/view', '部门查看'),
  userAdd: genUrl('/system/user/add', '用户新增'),
  userEdit: genUrl('/system/user/edit', '用户编辑'),
  userDelete: genUrl('/system/user/delete', '用户删除'),
  userActive: genUrl('/system/user/active', '用户启停'),
  userResetPwd: genUrl('/system/user/resetPwd', '用户登录密码重置'),
  userResetSendPwd: genUrl('/system/user/resetSendPwd', '用户发送密码重置'),
  userChgDepartment: genUrl('/system/user/chgDepartment', '用户变更部门'),
  userValidate: genUrl('/system/user/validate/do', '用户校验'),
  updatePwd: genUrl('/system/user/updatePwd', '修改密码'),
  userCenterView: genUrl('/system/user/userCenter/view'),
  userCenterUpdate: genUrl('/system/user/userCenter/update', '个人中心用户修改'),
  userHeadPic: genUrl('/system/user/userCenter/headPic', '上传用户头像'),
  overTimeUpdatePwd: genUrl('/overTimeUpdatePwd', '超期密码修改'),

  // #role urls
  role: genUrl('/system/role/list', '角色列表'),
  roleView: genUrl('/system/role/view', '角色查看'),
  roleAdd: genUrl('/system/role/add', '角色新增'),
  roleEdit: genUrl('/system/role/edit', '角色编辑'),
  roleDelete: genUrl('/system/role/delete', '角色删除'),
  roleDetail: genUrl('/system/role/detail', '角色详情'),
  roleValidate: genUrl('/system/role/validate', '角色校验'),
  permissions: genUrl('/system/role/permissions', '角色权限'),
  rolePermissions: genUrl('/system/role/rolePermissions', '角色权限'),
  viewPermissions: genUrl('/system/role/viewPermissions', '角色权限查看'),
  // #end role urls

  // #log record urls
  logRecord: genUrl('/system/log/list', '日志记录列表'),
  logRecordOperModule: genUrl('/system/log/operModule', '日志记录操作模块'),

  // #log records urls

  // #system config urls
  configBase: genUrl('/system/config/base', '系统基础配置'),
  findAllUsersDeptNode: genUrl('/system/config/getUserAccounts', '获取所有用户树状结构'),
  configSecurity: genUrl('/system/config/security', '系统密码安全配置'),
  configGateway: genUrl('/system/config/gateway', '系统网关配置'),
  configVoicePriority: genUrl('/system/config/defaultChannelConfig/voicePriority', '系统语音配置'),
  configDefaultChannel: genUrl('/system/config/defaultChannelConfig/defaultChannel', '系统默认渠道配置'),
  configSave: genUrl('/system/config/save', '系统配置保存'),
  configSaveDefaultChannel: genUrl('/system/config/save/defaultChannel', '系统渠道默认配置保存'),
  configBiztype: genUrl('/system/config/biztype/fetch', '获取默认业务类型设置'),
  configBiztypeSave: genUrl('/system/config/biztype/save', '修改默认业务类型设置'),
  configProviders: genUrl('/system/config/providers', '业务类型渠道商'),
  configChannel: genUrl('/system/config/channel', '业务类型渠道'),
  configChnnelNum: genUrl('/system/config/channelNum', '获取业务类型渠道号'),
  // #end system config urls

  // user push config url
  userPushConfig: genUrl('/system/userPushConfig/list', '推送协议管理列表'),
  userPushConfigAdd: genUrl('/system/userPushConfig/add', '推送协议新增'),
  userPushConfigEdit: genUrl('/system/userPushConfig/edit', '推送协议编辑'),
  userPushConfigDelete: genUrl('/system/userPushConfig/delete', '推送协议删除'),
  userPushConfigBatchDelete: genUrl('/system/userPushConfig/delete', '推送协议批量删除'),
  userPushConfigActive: genUrl('/system/userPushConfig/active', '推送协议启停'),
  userPushConfigDetail: genUrl('/system/userPushConfig/detail', '推送协议详情'),
  userPushConfigFindUsers: genUrl('/system/userPushConfig/findUsers', '获取用户'),
  userPushConfigDefaultParams: genUrl('/system/userPushConfig/defaultParams', '获取推送配置默认值'),
  // user push config end

  // #region biz center urls
  template: genUrl('/business/template/list', '模板列表'),
  templateModifyRecord: genUrl('/business/template/modifyRecord', '模板修改记录'),
  templateCardList: genUrl('/business/template/cardList', '模板修改记录'),
  templateBizTypes: genUrl('/business/biztype/bizTypes', '模板列表-业务类型'),
  templateGet: genUrl('/business/template/get', '获取模板列表'),
  templateUpdate: genUrl('/business/template/update', '模板更新'),
  templateAdd: genUrl('/business/template/add', '模板新增'),
  templateDelete: genUrl('/business/template/delete', '删除模板'),
  templateUpdateState: genUrl('/business/template/updateState', '启用/停用模板'),
  templateWechatTemplate: genUrl('/business/template/wechatTemplate', '微信模板列表'),
  templateWechatChannelCheck: genUrl('/business/template/checkWechatChannel', '微信渠道校验'),
  templateTag: genUrl('/business/template/tagList', '模板标签列表'),
  templateBizTypeById: genUrl('/business/template/bizType', '业务类型摘要'),
  templateBizType: genUrl('/business/template/bizType/list', '所有业务类型'),
  templateMediaUpload: genUrl('/business/template/media/upload', '模板抖音视频/图片上传'),
  templateMediaUploadState: genUrl('/business/template/media/uploadState', '模板抖音视频/图片上传状态'),
  templateMediaUploadCancel: genUrl('/business/template/media/cancel', '模板抖音视频/图片上传取消'),
  template5GReply: genUrl('/business/template/5g/reply', '模板5G自动回复关键字'),
  templatePatchGroup: genUrl('/business/template/patchGroup/list', '模板可使用的贴片组'),
  templatePatchGroupItem: genUrl('/business/template/patchGroup/patchItem', '模板可使用的贴片组里面的贴片项'),

  templateShortLinkWebsits: genUrl('/shorturl/targeturl/list', '模板可使用的短链里面的网址列表'),
  templateShortLinkDomains: genUrl('/shorturl/targeturl/getShortLinkList', '模板可使用的短链里面的短域名列表'),
  templateShortLinkGenerate: genUrl('/message/send/getShortUrl', '生成短链'),

  wechatTemplateGet: genUrl('/business/library/wechat/list', '查询微信模板列表'),
  wechatTemplateSync: genUrl('/business/library/wechat/syncTemplate', '同步微信模板'),
  officialAccountList: genUrl('/business/library/wechat/official/list', '查询已绑定的公众号'),

  biztype: genUrl('/business/biztype/list', '业务类型列表'),
  bizTypeModifyRecord: genUrl('/business/biztype/modifyRecord', '业务类型修改记录'),
  biztypeDelete: genUrl('/business/biztype/delete', '业务类型删除'),
  biztypeUpdateState: genUrl('/business/biztype/updateState', '启用/停用业务类型'),
  biztypeGet: genUrl('/business/biztype/get', '获取业务类型'),
  biztypeChannelProviders: genUrl('/business/biztype/providers', '业务类型详情-渠道商'),
  biztypeChannel: genUrl('/business/biztype/channel', '业务类型详情-渠道'),
  biztypeSmartGroup: genUrl('/business/biztype/smartCustomerGroup', '业务类型详情-智能客群'),
  biztypeUpdate: genUrl('/business/biztype/update', '更新业务类型'),
  biztypeAdd: genUrl('/business/biztype/add', '新增业务类型'),
  bizTypeNameValidate: genUrl('/business/biztype/nameExist', '业务类型名称校验'),
  bizTypeCodeValidate: genUrl('/business/biztype/codeExist', '业务类型编码校验'),
  bizTypeVar: genUrl('/business/biztype/var', '业务类型变量列表'),
  bizTypeTag: genUrl('/business/biztype/tagList', '业务类型标签列表'),
  bizDefaultChannels: genUrl('/business/biztype/defaultChannel', '默认渠道配置'),

  templateAudit: genUrl('/business/templateAudit/audit', '模板审核列表'),
  templateAuditDetail: genUrl('/business/templateAudit/audit/detail', '模板审核'),
  templateAuditCheck: genUrl('/business/templateAudit/audit/check', '模板审核'),
  templateAudited: genUrl('/business/templateAudit/audited', '模板审核列表'),
  templateAuditStat: genUrl('/business/templateAudit/audit/stat', '模板待审核统计'),

  biztypeAudit: genUrl('/business/biztypeAudit/audit', '业务类型审核列表'),
  biztypeAuditDetail: genUrl('/business/biztypeAudit/audit/detail', '业务类型待审核详情'),
  biztypeAuditCheck: genUrl('/business/biztypeAudit/audit/check', '业务类型审核'),
  biztypeAudited: genUrl('/business/biztypeAudit/audited', '业务类型审核记录'),
  biztypeAuditedDetail: genUrl('/business/biztypeAudit/audited/detail', '业务类型已审核详情'),

  materialAuditList: genUrl('/business/materialAudit/audit/list', '素材待审核列表'),
  materialAuditContent: genUrl('/business/materialAudit/audit/content', '素材待审核内容'),
  materialAuditDetail: genUrl('/business/materialAudit/audit/detail', '素材待审核详情'),
  materialAuditCheck: genUrl('/business/materialAudit/audit/check', '素材审核'),
  materialAuditedList: genUrl('/business/materialAudit/audited/list', '素材审核记录'),
  materialAuditedDetail: genUrl('/business/materialAudit/audited/detail', '素材已审核详情'),

  materialGetImg: genUrl('/business/material/img/list', '查询图片库列表'),
  materialAddImg: genUrl('/business/material/img/add', '图片新增'),
  materialDelImg: genUrl('/business/material/img/del', '图片删除'),
  materialUpdateImg: genUrl('/business/material/img/update', '图片修改'),
  materialImgUpload: genUrl('/business/material/img/upload/ftp', '素材上传'),
  materialGetVideo: genUrl('/business/material/video/list', '查询视频库列表'),
  materialAddVideo: genUrl('/business/material/video/add', '视频新增'),
  materialDelVideo: genUrl('/business/material/video/del', '视频删除'),
  materialUpdateVideo: genUrl('/business/material/video/update', '视频修改'),
  materialVideoUpload: genUrl('/business/material/video/upload/ftp', '素材上传'),
  materialGetAudio: genUrl('/business/material/audio/list', '查询音频库列表'),
  materialAddAudio: genUrl('/business/material/audio/add', '音频新增'),
  materialDelAudio: genUrl('/business/material/audio/del', '音频删除'),
  materialUpdateAudio: genUrl('/business/material/audio/update', '音频修改'),
  materialAudioUpload: genUrl('/business/material/audio/upload/ftp', '素材上传'),
  materialGetExpired: genUrl('/business/material/expired/list', '查询过期素材列表'),
  materialReAudit: genUrl('/business/material/expired/reAudit', '素材重审'),
  materialDelExpired: genUrl('/business/material/expired/del', '过期素材删除'),

  // #end biz center

  customerBizType: genUrl('/message/send/common/bizType/list', '业务类型'),
  customerGroup: genUrl('/message/send/customer/customerGroup/list', '收信人分组'),
  customer: genUrl('/message/send/customer/list', '收信人列表'),
  customerView: genUrl('/message/send/customer', '收信人查看'),
  customerImport: genUrl('/message/send/customer/import', '收信人导入'),
  sendMessage: genUrl('/message/send/doSend', '发送消息'),
  templateView: genUrl('/message/send/template/list', '模板查看'),
  strategyList: genUrl('/message/send/customer/strategy/list', '发送策略列表'),
  strategy: genUrl('/message/send/customer/strategy', '发送策略查看'),
  attachment: genUrl('/common/attachment/download', '附件下载'),
  uploadPercent: genUrl('/message/send/uploadState', '上传进度查看'),
  sendPercent: genUrl('/message/send/sendState', '发送进度查看'),
  uploadImage: genUrl('/message/send/common/uploadSendImage', '上传图片'),
  addressee: genUrl('/message/send/list', '发送中心'),
  msgSendPatchGroupUrl: genUrl('/message/send/patchGroup/list', '上传图片'),
  msgSendPatchItemUrl: genUrl('/message/send/patchGroup/patchItem', '发送中心'),

  // #infomation urls
  channelProvider: genUrl('/information/channelProvider/list', '渠道商列表'),
  channelProviderAdd: genUrl('/information/channelProvider/add', '渠道商新增'),
  channelProviderEdit: genUrl('/information/channelProvider/edit', '渠道商编辑'),
  channelProviderDelete: genUrl('/information/channelProvider/delete', '渠道商删除'),
  channelProviderView: genUrl('/information/channelProvider/view', '渠道商查看'),
  channelProviderDetail: genUrl('/information/channelProvider/detail', '渠道商详情'),
  channelProviderValidate: genUrl('/information/channelProvider/validate', '渠道商校验'),
  channelProviderValidateChannel: genUrl('/information/channelProvider/validate/hasChannel', '渠道商校验'),
  smsChannelManagement: genUrl('/information/channelManagement/list/' + _MSGTYPES.MT.SMS.type, '短信渠道'),
  voiceChannelManagement: genUrl('/information/channelManagement/list/' + _MSGTYPES.MT.VOICE.type, '语音渠道'),
  delSmsChannelManagement: genUrl('/information/channelManagement/sms/delete', '短信渠道删除'),
  delVoiceChannelManagement: genUrl('/information/channelManagement/voice/delete', '语音渠道删除'),
  addVoiceChannelManagement: genUrl('/information/channelManagement/voice/add', '语音渠道新增'),
  addSmsChannelManagement: genUrl('/information/channelManagement/sms/add', '短信渠道新增'),
  editVoiceChannelManagement: genUrl('/information/channelManagement/voice/edit', '语音渠道编辑'),
  editSmsChannelManagement: genUrl('/information/channelManagement/sms/edit', '短信渠道编辑'),
  searchChannelProvider: genUrl('/information/channelProvider/getList', '渠道商搜索'),
  smsChannelRegion: genUrl('/information/channelManagement/region', '地区列表获取'),
  oneSmsChannel: genUrl('/information/channelManagement/val/one/', '短信渠道信息获取'),
  channelActiveSms: genUrl('/information/channelManagement/active/sms', '短信渠道启停'),
  get5GChatBots: genUrl('/information/chatBotMenuManager/chatBotList', 'ChatBot列表'),
  get5GChatBotInfo: genUrl('/information/chatBotMenuManager/chatBotMenuSelect', 'ChatBot菜单信息查询'),
  get5GChatBotInfoAvailable: genUrl('/information/chatBotMenuManager/chatBotMenuAvailable', '从运营商获取ChatBot菜单信息'),
  clear5GChatBotInfo: genUrl('/information/chatBotMenuManager/chatBotMenuDelete', 'ChatBot菜单信息清空'),
  edit5GChatBotMenuInfo: genUrl('/information/chatBotMenuManager/chatBotMenuEdit', 'ChatBot菜单信息提交审核'),

  // chatbot基本信息 start
  chatBotInfoList: genUrl('/information/chatBotInfoManager/chatBotList', 'ChatBot基本信息列表查询'),
  chatBotInformationEdit: genUrl('/information/chatBotInfoManager/chatBotInformationEdit', 'ChatBot基本信息编辑'),
  chatBotInformationSelect: genUrl('/information/chatBotInfoManager/chatBotInformationSelect', 'ChatBot基本信息详情'),
  ChatBotInformationAvailable: genUrl('/information/chatBotInfoManager/ChatBotInformationAvailable', 'ChatBot基本信息详情'),
  chatBotInformationDelete: genUrl('/information/chatBotInfoManager/chatBotInformationDelete', 'ChatBot基本信息清空'),

  // end

  // 短信渠道费率与告警
  getSmsChannelManagementPriceRate: genUrl('/information/channelManagement/sms/priceRate', '短信渠道获取费率'),
  saveSmsChannelManagementPriceRate: genUrl('/information/channelManagement/sms/priceRate/save', '短信渠道费率设置'),
  SmsChannelManagementPriceRateHistory: genUrl('/information/channelManagement/sms/priceRate/history', '短信渠道查看费率修改历史'),
  getSmsChannelManagementChannelAlarm: genUrl('/information/channelManagement/sms/channelAlarm', '短信渠道获取告警配置'),
  saveSmsChannelManagementChannelAlarm: genUrl('/information/channelManagement/sms/channelAlarm/save', '短信渠道告警设置'),
  getSmsChannelManagementChannelAlarmAccount: genUrl('/information/channelManagement/sms/channelAlarm/getAccounts', '短信渠道告警通知人员获取'),
  // end

  channelActiveVoice: genUrl('/information/channelManagement/active/voice', '语音渠道启停'),
  channelActiveWechat: genUrl('/information/channelManagement/active/wechat', '微信渠道启停'),
  channelActiveEmail: genUrl('/information/channelManagement/active/email', '邮件渠道启停'),
  checkChannelName: genUrl('/information/channelManagement/val/checkName', '校验渠道名'),
  checkChannelIdentity: genUrl('/information/channelManagement/val/checkIdentity', '校验渠道标识'),
  checkChannelCarrierBizTypeBind: genUrl('/information/channelManagement/val/checkCarrier', '检验渠道运营商是否关联业务类型'),
  // wechat urls
  wechatChannelManagement: genUrl('/information/channelManagement/list/' + _MSGTYPES.MT.WECHAT.type, '微信渠道'),
  delWechatChannelManagement: genUrl('/information/channelManagement/wechat/delete', '微信渠道删除'),
  addWechatChannelManagement: genUrl('/information/channelManagement/wechat/add', '微信渠道新增'),
  editWechatChannelManagement: genUrl('/information/channelManagement/wechat/edit', '微信渠道编辑'),
  getWechatChannelManagement: genUrl('/information/channelManagement/wechat/getOfficialAccount', '获取微信公众号'),
  // wechat end
  // email urls
  emailChannelManagement: genUrl('/information/channelManagement/list/' + _MSGTYPES.MT.EMAIL.type, '邮件渠道'),
  delEmailChannelManagement: genUrl('/information/channelManagement/email/delete', '邮件渠道删除'),
  addEmailChannelManagement: genUrl('/information/channelManagement/email/add', '邮件渠道新增'),
  editEmailChannelManagement: genUrl('/information/channelManagement/email/edit', '邮件渠道编辑'),
  validateEmailChannel: genUrl('/information/channelManagement/email/validate', '邮件渠道编辑'),
  // email end
  // app start
  jPushChannelManagement: genUrl('/information/channelManagement/list/' + _MSGTYPES.MT.JPUSH.type, '极光推送渠道'),
  channelActiveJPush: genUrl('/information/channelManagement/active/jPush', '极光推送渠道启停'),
  delJpushManagement: genUrl('/information/channelManagement/jPush/delete', '极光推送渠道删除'),
  addJpushManagement: genUrl('/information/channelManagement/jPush/add', '极光推送渠道新增'),
  editJpushManagement: genUrl('/information/channelManagement/jPush/edit', '极光推送渠道编辑'),
  // app end

  // tiktok start
  tiktokChannelManagement: genUrl('/information/channelManagement/list/' + _MSGTYPES.MT.TIKTOK.type, '抖音渠道'),
  channelActiveTiktok: genUrl('/information/channelManagement/active/tiktok', '抖音渠道启停'),
  delTiktokManagement: genUrl('/information/channelManagement/tiktok/delete', '抖音渠道删除'),
  addTiktokManagement: genUrl('/information/channelManagement/tiktok/add', '抖音渠道新增'),
  editTiktokManagement: genUrl('/information/channelManagement/tiktok/edit', '抖音渠道编辑'),
  geTtiktokCodeUrl: genUrl('/information/channelManagement/tiktok/getCodeUrl/', '抖音渠道编辑'),
  // tiktok end

  // workWechat start
  workWechatChannelManagement: genUrl('/information/channelManagement/list/' + _MSGTYPES.MT.WORKWX.type, '企业微信渠道'),
  channelActiveWorkWechat: genUrl('/information/channelManagement/active/workWechat', '企业微信渠道启停'),
  delWorkWechatManagement: genUrl('/information/channelManagement/workWechat/delete', '企业微信渠道删除'),
  addWorkWechatManagement: genUrl('/information/channelManagement/workWechat/add', '企业微信渠道新增'),
  editWorkWechatManagement: genUrl('/information/channelManagement/workWechat/edit', '企业微信渠道编辑'),
  // workWechat end

  // 5g start
  _5gChannelManagement: genUrl('/information/channelManagement/list/' + _MSGTYPES.MT._5G.type, '5g消息渠道'),
  channelActive5g: genUrl('/information/channelManagement/active/5g', '5g消息渠道启停'),
  del5gChannel: genUrl('/information/channelManagement/5g/delete', '5g消息渠道删除'),
  add5gChannel: genUrl('/information/channelManagement/5g/add', '5g消息渠道新增'),
  edit5gChannel: genUrl('/information/channelManagement/5g/edit', '5g消息渠道编辑'),
  // 5g end

  // customerTagMeta urls start
  custometTagMetaList: genUrl('/information/tagLib/list', '获取标签类列表'),
  custometTagMetaAdd: genUrl('/information/tagLib/add', '新增标签类'),
  custometTagMetaEdit: genUrl('/information/tagLib/edit', '新增标签类'),
  custometTagMetaDelete: genUrl('/information/tagLib/delete', '删除标签类'),
  // 标签
  custometTagList: genUrl('/information/tagLib/tag/list', '获取标签列表'),
  custometTagAdd: genUrl('/information/tagLib/tag/add', '新增标签'),
  custometTagDelete: genUrl('/information/tagLib/tag/delete', '删除标签'),
  // custometTagMetaEdit: genUrl('/information/tagLib/edit', '编辑标签'),
  customerTagMetaImport: genUrl('/information/tagLib/import/handle', '标签类导入'),
  customerTagMetaExport: genUrl('/information/tagLib/export/handle', '标签类导出'),
  customerTagMetaStatus: genUrl('/information/tagLib/export/checkAttachmentStatus', '标签类导出状态查询'),
  uploadPercentCustomerTagMeta: genUrl('/information/tagLib/import/uploadState', '标签类上传进度查看'),
  // customerTagMeta urls end
  // bizVar
  bizVarList: genUrl('/information/bizVariable/bizVarList/', '获取变量列表'),
  bizVar: genUrl('/information/bizVariable/list', '获取变量列表'),
  bizVarAdd: genUrl('/information/bizVariable/add', '获取变量列表'),
  bizVarEdit: genUrl('/information/bizVariable/edit', '获取变量列表'),
  bizVarDelete: genUrl('/information/bizVariable/delete', '获取变量列表'),
  bizVarImport: genUrl('/information/bizVariable/import/handle', '变量导入'),
  bizVarExport: genUrl('/information/bizVariable/export/handle', '变量导出'),
  bizVarStatus: genUrl('/information/bizVariable/export/checkAttachmentStatus', '变量导出状态查询'),
  uploadPercentBizVar: genUrl('/information/bizVariable/import/uploadState', '变量上传进度查看'),
  checkBizVarCode: genUrl('/information/bizVariable/validate/checkCode', '检查code是否存在'),
  // bizVar end

  // #infomation urls end

  // #comm center customer urls
  customerGroupList: genUrl('/commCenter/addressBook/customerGroup/list', '客户组列表'),
  customerGroupEdit: genUrl('/commCenter/addressBook/customerGroup/edit', '客户组编辑'),
  customerGroupAdd: genUrl('/commCenter/addressBook/customerGroup/add', '客户组新增'),
  customerGroupDelete: genUrl('/commCenter/addressBook/customerGroup/delete', '客户组删除'),
  customerGroupgetSuperior: genUrl('/commCenter/addressBook/customerGroup/getSuperiorGroups', '客户组获取'),
  customerGroupSub: genUrl('/commCenter/addressBook/customerGroup/sub', '客户组获取'),
  customerGroupGetAllSub: genUrl('/commCenter/addressBook/customerGroup/getAllSub', '客户组获取'),
  customerGroupFindById: genUrl('/commCenter/addressBook/customerGroup/findById', '客户组查找'),
  customerList: genUrl('/commCenter/addressBook/customer/list', '客户列表'),
  customerEdit: genUrl('/commCenter/addressBook/customer/edit', '客户编辑'),
  customerAdd: genUrl('/commCenter/addressBook/customer/add', '客户新增'),
  customerDelete: genUrl('/commCenter/addressBook/customer/delete', '客户删除'),
  customerImport2: genUrl('/commCenter/addressBook/customer/import/handle', '客户导入'),
  uploadPercent2: genUrl('/commCenter/addressBook/customer/import/uploadState', '客户上传进度查看'),
  customerExport: genUrl('/commCenter/addressBook/customer/export', '客户导出'),
  customerCheckAttachmentStatus: genUrl('/commCenter/addressBook/customer/export/checkAttachmentStatus', '客户导出状态查询'),
  customerActive: genUrl('/commCenter/addressBook/customer/active', '客户启停'),
  customerPhone: genUrl('/commCenter/addressBook/customer/phone', '客户查询'),
  customerAddRelation: genUrl('/commCenter/addressBook/customer/addRelation', '客户添加关系'),
  customerByGroupId: genUrl('/commCenter/addressBook/customer/import/findByGroupId', '查找组下所有id'),
  customerGroupCheckContainsCustomer: genUrl('/commCenter/addressBook/customerGroup/checkContainsCustomer', '检查分组是否存在客户'),
  customerTagBind: genUrl('/commCenter/addressBook/customer/customerTagBind', '客户标签绑定'),
  customerTagBindGet: genUrl('/commCenter/addressBook/customer/getCustomerTagBind', '获取客户标签'),
  customerGetChannelInfo: genUrl('/commCenter/addressBook/getChannelInfo', '获取渠道信息'),
  // # comm center customer urls end

  // #comm center employeeAddressBook urls
  employeeGroupList: genUrl('/commCenter/employeeAddressBook/employeeGroup/list', '员工组列表'),
  employeeGroupEdit: genUrl('/commCenter/employeeAddressBook/employeeGroup/edit', '员工组编辑'),
  employeeGroupAdd: genUrl('/commCenter/employeeAddressBook/employeeGroup/add', '员工组新增'),
  employeeGroupDelete: genUrl('/commCenter/employeeAddressBook/employeeGroup/delete', '员工组删除'),
  employeeGroupgetSuperior: genUrl('/commCenter/employeeAddressBook/employeeGroup/getSuperiorGroups', '员工组获取'),
  employeeGroupSub: genUrl('/commCenter/employeeAddressBook/employeeGroup/sub', '员工组获取'),
  employeeGroupGetAllSub: genUrl('/commCenter/employeeAddressBook/employeeGroup/getAllSub', '员工组获取'),
  employeeGroupFindById: genUrl('/commCenter/employeeAddressBook/employeeGroup/findById', '员工组查找'),
  employeeList: genUrl('/commCenter/employeeAddressBook/employee/list', '员工列表'),
  employeeEdit: genUrl('/commCenter/employeeAddressBook/employee/edit', '员工编辑'),
  employeeAdd: genUrl('/commCenter/employeeAddressBook/employee/add', '员工新增'),
  employeeDelete: genUrl('/commCenter/employeeAddressBook/employee/delete', '员工删除'),
  employeePosition: genUrl('/commCenter/employeeAddressBook/employee/getPosition', '职位获取'),
  employeeImport2: genUrl('/commCenter/employeeAddressBook/employee/import/handle', '员工导入'),
  employeeUploadPercent: genUrl('/commCenter/employeeAddressBook/employee/import/uploadState', '员工上传进度查看'),
  employeeExport: genUrl('/commCenter/employeeAddressBook/employee/export', '员工导出'),
  employeeCheckAttachmentStatus: genUrl('/commCenter/employeeAddressBook/employee/export/checkAttachmentStatus', '员工导出状态查询'),
  employeeActive: genUrl('/commCenter/employeeAddressBook/employee/active', '员工启停'),
  employeePhone: genUrl('/commCenter/employeeAddressBook/employee/phone', '员工查询'),
  employeeAddRelation: genUrl('/commCenter/employeeAddressBook/employee/addRelation', '员工添加关系'),
  employeeByGroupId: genUrl('/commCenter/employeeAddressBook/employee/import/findByGroupId', '查找组下所有id'),
  employeeGroupCheckContainsEmployee: genUrl('/commCenter/employeeAddressBook/employeeGroup/checkContainsEmployee', '检查分组是否存在员工'),
  employeeGetChannelInfo: genUrl('/commCenter/employeeAddressBook/getChannelInfo', '获取渠道信息'),
  // # comm center employeeAddressBook urls end

  // #comm center  urls
  smartCustomerGroupList: genUrl('/commCenter/smartCusGroup/customerGroup/list', '客户群列表'),
  smartCustomerGroupEdit: genUrl('/commCenter/smartCusGroup/customerGroup/edit', '客户群编辑'),
  smartCustomerGroupAdd: genUrl('/commCenter/smartCusGroup/customerGroup/add', '客户群新增'),
  smartCustomerGroupDelete: genUrl('/commCenter/smartCusGroup/customerGroup/delete', '客户群删除'),
  smartCustomerGroupTagList: genUrl('/commCenter/smartCusGroup/customerGroup/verify/tagList', '自动完成获取元标签列表'),

  smartCustomerList: genUrl('/commCenter/smartCusGroup/customer/list', '客户通讯录列表'),
  smartCustomerDetail: genUrl('/commCenter/smartCusGroup/customer/detail', '客户通讯录详情'),
  smartCustomerTagMsg: genUrl('/commCenter/smartCusGroup/customer/tagMsg', '客户标签信息'),
  getSmartWechatOfficialAccount: genUrl('/commCenter/smartCusGroup/customer/getOfficialAccount', '获取微信公众号'),
  // # comm center smartCustomerGroup urls end

  // #comm center  wechatFans urls
  wechatFansGroupList: genUrl('/commCenter/wechatFansMgt/wechatFansGroup/list', '微信分组列表'),
  wechatFansGroupNode: genUrl('/commCenter/wechatFansMgt/wechatFansGroup/view', '微信粉丝标签列表'),
  wechatFansGroupEdit: genUrl('/commCenter/wechatFansMgt/wechatFansGroup/edit', '微信分组编辑'),
  wechatFansGroupAdd: genUrl('/commCenter/wechatFansMgt/wechatFansGroup/add', '微信分组新增'),
  wechatFansGroupDelete: genUrl('/commCenter/wechatFansMgt/wechatFansGroup/delete', '微信分组删除'),
  wechatFansGroupCheckName: genUrl('/commCenter/wechatFansMgt/wechatFansGroup/checkName', '微信分组名称检查'),
  wechatFansGroupFindAll: genUrl('/commCenter/wechatFansMgt/wechatFansGroup/findAll', '获取分组操作下的所有分组'),
  wechatFansList: genUrl('/commCenter/wechatFansMgt/wechatFans/list', '微信粉丝列表'),
  wechatFansUpdate: genUrl('/commCenter/wechatFansMgt/wechatFans/updateFans', '更新微信粉丝'),
  wechatFansGrouping: genUrl('/commCenter/wechatFansMgt/wechatFans/grouping', '微信粉丝分组'),
  wechatFansbatchGrouping: genUrl('/commCenter/wechatFansMgt/wechatFans/batchGrouping', '微信粉丝批量分组'),
  wechatFansAddBlackList: genUrl('/commCenter/wechatFansMgt/wechatFans/addBlackList', '加入黑名单'),
  wechatFansRemoveBlackList: genUrl('/commCenter/wechatFansMgt/wechatFans/removeBlackList', '移除黑名单'),
  // #comm center wechatFans urls

  // #comm center work wechat urls
  workWechatDeptsList: genUrl('/commCenter/workWechatAddressBook/departments/list', '企业微信通讯录部门查询'),
  workWechatUsersList: genUrl('/commCenter/workWechatAddressBook/users/list', '企业微信通讯录员工查询'),
  workWechatDeptUpdate: genUrl('/commCenter/workWechatAddressBook/departments/update', '企业微信通讯录部门更新'),
  workWechatUsersUpdate: genUrl('/commCenter/workWechatAddressBook/users/update', '企业微信通讯录员工更新'),
  // #comm center work wechat urls

  // #comm center tiktok urls
  tiktokAccountList: genUrl('/commCenter/tiktokFansMgt/accountList', '抖音号列表查询'),
  tiktokFansList: genUrl('/commCenter/tiktokFansMgt/fansList', '粉丝列表查询'),
  tiktokFansUpdate: genUrl('/commCenter/tiktokFansMgt/updateFans', '更新微信粉丝'),
  // #comm center tiktok urls

  // #common resource
  msgTypes: genUrl('/common/msgTypes', '消息类型'),
  applicationTypesAll: genUrl('/common/applicationTypes' + '/1', '应用类型'),
  applicationTypesWechat: genUrl('/common/applicationTypes' + '/0', '微信应用类型'),
  sendMethods: genUrl('/common/sendMethods', '发送策略'),
  templateStates: genUrl('/common/templateStates', '模板状态'),
  bizCode: genUrl('/common/bizCode', '业务类型编码'),
  templateMaxLimit: genUrl('/common/templateMaxLimit', '最大模板数限制'),
  encryptRule: genUrl('/common/encryptRule?_allow_anonymous=true', '获取加密方式以及加密规则'),
  pubKey: genUrl('/common/pubKey?_allow_anonymous=true', '获取加密方式以及加密规则'),
  // #endregion

  // #msgRecord urls
  sendRecord: genUrl('/msgRecord/sendRecord/list', '发送记录'),
  sendRecordBizTypes: genUrl('/msgRecord/sendRecord/bizs', '发送记录业务类型'),
  sendRecordDetail: genUrl('/msgRecord/sendRecord/detailList', '发送记录详情'),
  sendRecordStrategy: genUrl('/msgRecord/sendRecord/detailStrategy', '发送记录执行策略'),
  sendRecordExport: genUrl('/msgRecord/sendRecord/export', '发送记录导出'),
  sendRecordCheckAttachmentStatus: genUrl('/msgRecord/sendRecord/export/checkAttachmentStatus', '发送记录导出状态查询'),
  smsSendRecordDetail: genUrl('/msgRecord/sendRecord/detail/' + _MSGTYPES.MT.SMS.type, '发送记录短信发送详情'),
  voiceSendRecordDetail: genUrl('/msgRecord/sendRecord/detail/' + _MSGTYPES.MT.VOICE.type, '发送记录语音发送详情'),
  wechatSendRecordDetail: genUrl('/msgRecord/sendRecord/detail/' + _MSGTYPES.MT.WECHAT.type, '发送记录微信发送详情'),
  emailSendRecordDetail: genUrl('/msgRecord/sendRecord/detail/' + _MSGTYPES.MT.EMAIL.type, '发送记录邮件发送详情'),
  tiktokSendRecordDetail: genUrl('/msgRecord/sendRecord/detail/' + _MSGTYPES.MT.TIKTOK.type, '发送记录抖音发送详情'),
  jpushSendRecordDetail: genUrl('/msgRecord/sendRecord/detail/' + _MSGTYPES.MT.JPUSH.type, '发送记录极光推送发送详情'),
  workwxSendRecordDetail: genUrl('/msgRecord/sendRecord/detail/' + _MSGTYPES.MT.WORKWX.type, '发送记录企业微信发送详情'),
  _5gSendRecordDetail: genUrl('/msgRecord/sendRecord/detail/' + _MSGTYPES.MT._5G.type, '发送记录5G发送详情'),

  packAuditedList: genUrl('/message/packAudit/audited/list', '批次已审核列表'),
  packAuditList: genUrl('/message/packAudit/audit/list', '批次待审核列表'),
  packAudit: genUrl('/message/packAudit/audit', '执行批次审核'),
  packDetail: genUrl('/message/packAudit/packDetail', '审核批次详情'),
  channelInfo: genUrl('/message/send/getChannelInfo', '获取通道信息'),

  sendAuditStat: genUrl('/message/packAudit/audit/stat', '发送待审核统计'),
  marketingPatchAuditStat: genUrl('/business/patchAudit/audit/stat', '营销贴片待审核统计'),
  biztypeAuditStat: genUrl('/business/biztypeAudit/audit/stat', '业务类型待审核统计'),

  cancelSend: genUrl('/msgRecord/sendRecord/cancel', '取消发送'),

  smsSendDetail: genUrl('/msgRecord/sendDetail/list/sms/', '短信发送详情'),
  smsSendDetailExport: genUrl('/msgRecord/sendDetail/export/sms', '短信发送详情导出'),
  smsSubList: genUrl('/msgRecord/sendDetail/list/sms/getSubList', '短信分段列表'),

  voiceSendDetail: genUrl('/msgRecord/sendDetail/list/voice', '语音发送详情'),
  voiceSendDetailExport: genUrl('/msgRecord/sendDetail/export/voice', '语音发送详情导出'),

  wechatSendDetail: genUrl('/msgRecord/sendDetail/list/wechat', '微信发送详情'),
  wechatSendDetailExport: genUrl('/msgRecord/sendDetail/export/wechat', '微信发送详情导出'),

  emailSendDetail: genUrl('/msgRecord/sendDetail/list/email', '邮件发送详情'),
  emailSendDetailExport: genUrl('/msgRecord/sendDetail/export/email', '邮件发送详情导出'),

  tiktokSendDetail: genUrl('/msgRecord/sendDetail/list/tiktok', '抖音发送详情'),
  tiktokSendDetailExport: genUrl('/msgRecord/sendDetail/export/tiktok', '抖音发送详情导出'),

  jpushSendDetail: genUrl('/msgRecord/sendDetail/list/jpush', '极光推送发送详情'),
  jpushSendDetailExport: genUrl('/msgRecord/sendDetail/export/jpush', '极光推送发送详情导出'),

  workwxSendDetail: genUrl('/msgRecord/sendDetail/list/workwx', '企业微信发送详情'),
  workwxSendDetailExport: genUrl('/msgRecord/sendDetail/export/workwx', '企业微信发送详情导出'),

  _5gSendDetail: genUrl('/msgRecord/sendDetail/list/_5g', '5G发送详情'),
  _5gSendDetailExport: genUrl('/msgRecord/sendDetail/export/_5g', '5G发送详情导出'),

  smsMoRecord: genUrl('/msgRecord/moRecord/list/sms', '短信上行记录'),
  smsMoRecordExport: genUrl('/msgRecord/moRecord/export/sms', '短信上行记录导出'),

  voiceMoRecord: genUrl('/msgRecord/moRecord/list/voice', '语音上行记录'),
  voiceMoRecordExport: genUrl('/msgRecord/moRecord/export/voice', '语音上行记录导出'),

  wechatMoRecord: genUrl('/msgRecord/moRecord/list/wechat', '微信上行记录'),
  wechatMoRecordExport: genUrl('/msgRecord/moRecord/export/wechat', '微信上行记录导出'),

  emailMoRecord: genUrl('/msgRecord/moRecord/list/email', '邮件上行记录'),
  emailMoRecordExport: genUrl('/msgRecord/moRecord/export/email', '邮件上行记录导出'),

  workwxMoRecord: genUrl('/msgRecord/moRecord/list/workwx', '企业微信上行记录'),
  workwxMoRecordExport: genUrl('/msgRecord/moRecord/export/workwx', '企业微信上行记录导出'),

  _5gMoRecord: genUrl('/msgRecord/moRecord/list/_5g', '5G上行记录'),
  _5gMoRecordExport: genUrl('/msgRecord/moRecord/export/_5g', '5G上行记录导出'),

  tiktokMoRecord: genUrl('/msgRecord/moRecord/list/tiktok', '抖音上行记录'),
  tiktokMoRecordExport: genUrl('/msgRecord/moRecord/export/tiktok', '抖音上行记录导出'),

  smsMoRecordManuallyCallBack: genUrl('/msgRecord/moRecord/manuallyCallBack', '手动回复'),
  timeRecordList: genUrl('/msgRecord/timeRecord/list/', '消息交互时间轴上下行数据列表'),
  getCustomerName: genUrl('/msgRecord/timeRecord/list/getCustomerName', '根据编码获取客户名称'),
  autoComplete: genUrl('/msgRecord/timeRecord/list/autoComplete', '根据编码或者名称模糊查询'),
  // #endregion

  // sms auto reply urls start
  smsAutoReply: genUrl('/msgRecord/msgAutomationEngine/autoReply/sms/list', '查询'),
  smsAutoReplyAdd: genUrl('/msgRecord/msgAutomationEngine/autoReply/sms/add', '新增'),
  smsAutoReplyEdit: genUrl('/msgRecord/msgAutomationEngine/autoReply/sms/edit', '编辑'),
  smsAutoReplyDelete: genUrl('/msgRecord/msgAutomationEngine/autoReply/sms/delete', '删除'),
  smsAutoReplyActive: genUrl('/msgRecord/msgAutomationEngine/autoReply/sms/active', '启停'),
  smsAutoReplyDetail: genUrl('/msgRecord/msgAutomationEngine/autoReply/sms/detail', '查看详情'),
  smsAutoReplyGetAccounts: genUrl('/msgRecord/msgAutomationEngine/autoReply/sms/getAccounts', '关联账号获取'),
  smsAutoReplyKeywordExist: genUrl('/msgRecord/msgAutomationEngine/autoReply/sms/keywordExist', 'keyword远程唯一性校验'),
  // sms auto reply urls end

  // auto blackList urls start
  autoBlackList: genUrl('/msgRecord/msgAutomationEngine/autoBlacklist/list', '查询'),
  autoBlackListAdd: genUrl('/msgRecord/msgAutomationEngine/autoBlacklist/add', '新增'),
  autoBlackListEdit: genUrl('/msgRecord/msgAutomationEngine/autoBlacklist/edit', '编辑'),
  autoBlackListDelete: genUrl('/msgRecord/msgAutomationEngine/autoBlacklist/delete', '删除'),
  autoBlackListActive: genUrl('/msgRecord/msgAutomationEngine/autoBlacklist/active', '启停'),
  autoBlackListDetail: genUrl('/msgRecord/msgAutomationEngine/autoReply/sms/detail', '查看详情'),
  autoBlackListGetAccounts: genUrl('/msgRecord/msgAutomationEngine/autoBlacklist/getAccounts', '关联账号获取'),
  autoBlackListKeywordExist: genUrl('/msgRecord/msgAutomationEngine/autoBlacklist/keywordExist', 'keyword远程唯一性校验'),
  // auto blackList urls end
  workWxAppList: genUrl('/common/getChannelListByMsgType/8', '企业微信应用查询'),
  wechatAppList: genUrl('/common/getChannelListByMsgType/2', '微信公众号查询'),

  // wechat auto reply urls start
  wechatAutoReply: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/list', '查询'),
  wechatAutoReplyActive: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/active', '启停'),
  wechatAutoReplyOfficialAccounts: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/getChannelInfo', '公众号获取'),
  wechatKeyword: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/keyword/list', '关键字查询'),
  wechatKeywordAdd: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/keyword/add', '关键字新增'),
  wechatKeywordEdit: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/keyword/edit', '关键字修改'),
  wechatKeywordDelete: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/keyword/delete', '关键字删除'),
  wechatKeywordActive: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/keyword/active', '关键字启停'),
  wechatKeywordDetail: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/keyword/detail', '关键字查看详情'),
  wechatKeywordGetAccounts: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/keyword/getAccounts', '关联账号获取'),
  wechatKeywordKeywordExist: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/keyword/keywordExist', 'keyword远程唯一性校验'),
  wechatKeywordRuleExist: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/keyword/ruleExist', 'rule远程唯一性校验'),

  wechatSubscribe: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/subscribe/info', '新关注回复获取'),
  wechatSubscribeSave: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/subscribe/add', '新关注回复保存'),
  wechatSubscribeDelete: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/subscribe/delete', '新关注回复删除'),

  wechatReceive: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/receive/info', '接收消息回复获取'),
  wechatReceiveSave: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/receive/add', '接收消息回复保存'),
  wechatReceiveDelete: genUrl('/msgRecord/msgAutomationEngine/autoReply/wechat/receive/delete', '接收消息回复删除'),
  // wechat auto reply urls end

  // mail auto reply urls start
  mailAutoReply: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/list', '查询'),
  mailAutoReplyActive: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/active', '启停'),
  mailAutoReplyGetmail: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/getChannelInfo', '邮箱地址获取'),
  mailKeyword: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/keyword/list', '关键字查询'),
  mailKeywordAdd: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/keyword/add', '关键字新增'),
  mailKeywordEdit: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/keyword/edit', '关键字修改'),
  mailKeywordDelete: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/keyword/delete', '关键字删除'),
  mailKeywordActive: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/keyword/active', '关键字启停'),
  mailKeywordDetail: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/keyword/detail', '关键字查看详情'),
  mailKeywordGetAccounts: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/keyword/getAccounts', '关联账号获取'),
  mailKeywordKeywordExist: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/keyword/keywordExist', 'keyword远程唯一性校验'),
  mailKeywordRuleExist: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/keyword/ruleExist', 'rule远程唯一性校验'),

  mailReceive: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/receive/info', '接收消息回复获取'),
  mailReceiveSave: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/receive/add', '接收消息回复保存'),
  mailReceiveDelete: genUrl('/msgRecord/msgAutomationEngine/autoReply/mail/receive/delete', '接收消息回复删除'),
  // mail auto reply urls end

  // 5g auto reply urls start
  _5GAutoReply: genUrl('/msgRecord/msgAutomationEngine/autoReply/_5g/list', '查询'),
  _5GAutoReplyAdd: genUrl('/msgRecord/msgAutomationEngine/autoReply/_5g/add', '新增'),
  _5GAutoReplyEdit: genUrl('/msgRecord/msgAutomationEngine/autoReply/_5g/edit', '编辑'),
  _5GAutoReplyDelete: genUrl('/msgRecord/msgAutomationEngine/autoReply/_5g/delete', '删除'),
  _5GAutoReplyActive: genUrl('/msgRecord/msgAutomationEngine/autoReply/_5g/active', '启停'),
  _5GAutoReplyDetail: genUrl('/msgRecord/msgAutomationEngine/autoReply/_5g/detail', '查看详情'),
  _5GAutoReplyKeywordExist: genUrl('/msgRecord/msgAutomationEngine/autoReply/_5g/keywordExist', 'keyword远程唯一性校验'),
  _5GAutoReplyChannelInfo: genUrl('/msgRecord/msgAutomationEngine/autoReply/_5g/getChannelInfo', '5G所属渠道'),

  // 5g end

  // 公共素材库 start *******
  quoteMaterial: genUrl('/business/material/common/quoteMaterial'),
  quoteRecord: genUrl('/business/material/common/quoteRecord'),
  editPoster: genUrl('/business/material/common/video/editPoster', '批量修改封面'),
  // 公共素材库 end *******

  // 5g素材库
  MaterialStatistic: genUrl('/business/material/statistic'),
  AddImgMaterialGroup: genUrl('/business/material/img/addGroup'),
  updateImgMaterialGroup: genUrl('/business/material/img/updateGroup'),
  deleteImgMaterialGroup: genUrl('/business/material/img/deleteGroup'),
  listImgMaterialGroup: genUrl('/business/material/img/listGroup'),
  AddVideoMaterialGroup: genUrl('/business/material/video/addGroup'),
  updateVideoMaterialGroup: genUrl('/business/material/video/updateGroup'),
  deleteVideoMaterialGroup: genUrl('/business/material/video/deleteGroup'),
  listVideoMaterialGroup: genUrl('/business/material/video/listGroup'),
  AddAudioMaterialGroup: genUrl('/business/material/audio/addGroup'),
  updateAudioMaterialGroup: genUrl('/business/material/audio/updateGroup'),
  deleteAudioMaterialGroup: genUrl('/business/material/audio/deleteGroup'),
  listAudioMaterialGroup: genUrl('/business/material/audio/listGroup'),

  // workwx auto reply urls start
  workwxAutoReply: genUrl('/msgRecord/msgAutomationEngine/autoReply/workwx/list', '查询'),
  workwxAutoReplyActive: genUrl('/msgRecord/msgAutomationEngine/autoReply/workwx/active', '启停'),
  wechatAutoReplyKeyword: genUrl('/msgRecord/msgAutomationEngine/autoReply/workwx/keyword/list', '关键字查询'),
  workwxAutoReplyKeywordAdd: genUrl('/msgRecord/msgAutomationEngine/autoReply/workwx/keyword/add', '新增'),
  workwxAutoReplyKeywordEdit: genUrl('/msgRecord/msgAutomationEngine/autoReply/workwx/keyword/edit', '编辑'),
  workwxAutoReplyKeywordDelete: genUrl('/msgRecord/msgAutomationEngine/autoReply/workwx/keyword/delete', '删除'),
  workwxAutoReplyKeywordDetail: genUrl('/msgRecord/msgAutomationEngine/autoReply/workwx/keyword/detail', '查看详情'),

  workwxKeywordGetAccounts: genUrl('/msgRecord/msgAutomationEngine/autoReply/workwx/keyword/getAccounts', '关联账号获取'),
  workwxKeywordKeywordExist: genUrl('/msgRecord/msgAutomationEngine/autoReply/workwx/keyword/keywordExist', 'keyword远程唯一性校验'),
  workwxKeywordRuleExist: genUrl('/msgRecord/msgAutomationEngine/autoReply/workwx/keyword/ruleExist', 'rule远程唯一性校验'),
  // workwx end

  // auto report
  autoReport: genUrl('/msgRecord/msgAutomationEngine/autoReport/list', '查询'),
  autoReportAdd: genUrl('/msgRecord/msgAutomationEngine/autoReport/add', '新增'),
  autoReportEdit: genUrl('/msgRecord/msgAutomationEngine/autoReport/edit', '编辑'),
  autoReportDelete: genUrl('/msgRecord/msgAutomationEngine/autoReport/delete', '删除'),
  autoReportActive: genUrl('/msgRecord/msgAutomationEngine/autoReport/active', '启停'),
  autoReportDetail: genUrl('/msgRecord/msgAutomationEngine/autoReport/detail', '查看详情'),
  autoReportGetAccounts: genUrl('/msgRecord/msgAutomationEngine/autoReport/getAccounts', '关联账号获取'),
  autoReportKeywordExist: genUrl('/msgRecord/msgAutomationEngine/autoReport/keywordExist', 'keyword远程唯一性校验'),
  // auto report end

  // tiktok comment urls start
  tiktokCommentMedia: genUrl('/msgRecord/comment/tiktok/commentMedia/list', '广播消息查询'),
  tiktokCommentItem: genUrl('/msgRecord/comment/tiktok/commentItem/list', '评论查询'),
  makeCommentTopOrCancel: genUrl('/msgRecord/comment/tiktok/makeCommentTopOrCancel', '置顶或者取消置顶'),
  replyTiktokComment: genUrl('/msgRecord/comment/tiktok/replyTiktokComment', '回复评论'),
  replyTiktokCommentBatch: genUrl('/msgRecord/comment/tiktok/replyTiktokCommentBatch', '回复评论'),
  pullMediaCommentFromTiktok: genUrl('/msgRecord/comment/tiktok/pullMediaCommentFromTiktok', '手动拉取回复评论'),
  // tiktok end

  // wechat comment urls start
  wechatCommentMedia: genUrl('/msgRecord/comment/wechatCommont/commentMedia/list', '群发消息查询'),
  wechatCommentItem: genUrl('/msgRecord/comment/wechatCommont/commentItem/list', '评论查询'),
  makeCommentHandpickOrCancel: genUrl('/msgRecord/comment/wechat/makeCommentHandpickOrCancel', '置顶或者取消置顶'),
  deleteComment: genUrl('/msgRecord/comment/wechat/deleteComment', '删除评论'),
  deleteCommentBatch: genUrl('/msgRecord/comment/wechat/deleteCommentBatch', '删除评论'),
  deleteCommentReply: genUrl('/msgRecord/comment/wechat/deleteCommentReply', '删除评论'),
  replyWechatComment: genUrl('/msgRecord/comment/wechat/replyWechatComment', '回复评论'),
  replyWechatCommentBatch: genUrl('/msgRecord/comment/wechat/replyWechatCommentBatch', '回复评论'),
  pullMediaCommentFromWechat: genUrl('/msgRecord/comment/wechat/pullMediaCommentFromWechat', '手动拉取回复评论'),
  // wechat end

  // 统计模块stat
  // 业务类型统计
  bizTypeStat: genUrl('/stat/bizType/list', '业务类型统计列表'),
  bizTypeStatExport: genUrl('/stat/bizType/export/handle', '业务类型统计导出'),
  bizTypeStatGetBizs: genUrl('/stat/bizType/bizs', '获取所有业务类型'),
  bizTypeStatExportStatus: genUrl('/stat/bizType/export/checkAttachmentStatus', '业务类型统计导出状态'),
  singleTypeBizStat: genUrl('/stat/bizType/singleType', '业务类型单个消息类型统计'),
  // 渠道商统计
  providerStat: genUrl('/stat/provider/list', '渠道商统计列表'),
  providerExport: genUrl('/stat/provider/export/handle', '渠道商统计导出'),
  providerExportStatu: genUrl('/stat/provider/export/checkAttachmentStatus', '渠道商统计导出状态'),
  singleTypeProviderStat: genUrl('/stat/provider/singleType', '渠道商单个消息类型统计'),
  providerListWithoutRemove: genUrl('/stat/provider/getList', '获取所有渠道商列表'),
  // 标签热词统计
  hogTagStat: genUrl('/stat/hotTag/list', '标签热词统计列表'),
  hotTagExport: genUrl('/stat/hotTag/export/handle', '标签热词统计导出'),
  allTagMeta: genUrl('/stat/hotTag/tag/meta', '查询所有标签类'),
  allTag: genUrl('/stat/hotTag/tag', '查询所有标签类下的标签'),
  hotTagExportStatu: genUrl('/stat/hotTag/export/checkAttachmentStatus', '标签热词统计导出状态'),

  // 消息类型统计
  allUsers: genUrl('/stat/msgType/user', '查询所有用户'),
  // 短信类型统计
  msgTypeSmsStat: genUrl('/stat/msgType/list/0', '短信消息类型统计列表'),
  msgTypeSmsExport: genUrl('/stat/msgType/export/handle/0', '短信消息统计导出'),
  msgTypeSmsExportStatu: genUrl('/stat/msgType/export/checkAttachmentStatus/0', '短信消息统计导出状态'),

  // 语音类型统计
  msgTypeVoiceStat: genUrl('/stat/msgType/list/3', '语音消息类型统计列表'),
  msgTypeVoiceExport: genUrl('/stat/msgType/export/handle/3', '语音消息统计导出'),
  msgTypeVoiceExportStatu: genUrl('/stat/msgType/export/checkAttachmentStatus/3', '语音消息统计导出状态'),
  // 微信类型统计
  msgTypeWechatStat: genUrl('/stat/msgType/list/2', '微信消息类型统计列表'),
  msgTypeWechatExport: genUrl('/stat/msgType/export/handle/2', '微信消息统计导出'),
  msgTypeWechatExportStatu: genUrl('/stat/msgType/export/checkAttachmentStatus/2', '微信消息统计导出状态'),
  // 短信类型统计
  msgTypeEmailStat: genUrl('/stat/msgType/list/4', '邮件消息类型统计列表'),
  msgTypeEmailExport: genUrl('/stat/msgType/export/handle/4', '邮件消息统计导出'),

  // 标签热词Top20统计
  hotTagTop20: genUrl('/stat/hotTag/top20', '标签热词Top20统计'),
  // 业务类型发送Top5统计
  bizTypeSendTop5: genUrl('/stat/bizType/top5', '业务类型发送Top5统计'),
  // 消息类型发送量统计
  msgTypeSendCount: genUrl('/stat/msgType/sendCount', '消息类型发送量统计'),
  // 消息类型上行量统计
  msgTypeMoCount: genUrl('/stat/msgType/moCount', '消息类型上行量统计'),
  // 消息总量统计
  msgTypeAllCount: genUrl('/stat/msgType/allCount', '消息总量统计'),
  // 消息总量每日统计
  msgTypeAllCountByDay: genUrl('/stat/msgType/allCountByDay', '消息总量每日统计'),
  msgTypeEmailExportStatu: genUrl('/stat/msgType/export/checkAttachmentStatus/4', '邮件消息统计导出状态'),

  // 运营周月报
  reportTaskUsers: genUrl('/stat/report/task/getTaskUsers', '获取配置列表中所有用户'),
  reportTaskList: genUrl('/stat/report/task/list', '查询报表配置列表'),
  reportTaskAdd: genUrl('/stat/report/task/add', '报表配置列表新增'),
  reportTaskUpdate: genUrl('/stat/report/task/update', '报表配置列表修改'),
  reportTaskDelete: genUrl('/stat/report/task/delete', '报表配置列表删除'),
  reportTaskActive: genUrl('/stat/report/task/active', '报表配置列表启停'),
  reportHistoryList: genUrl('/stat/report/history/list', '报表历史列表查询'),

  // 社交运营分析-微信模块
  officialAccountStatList: genUrl('/stat/social/wechat/officialAccount/list', '获取已接入ICC系统的微信公众号列表'),
  officialAccountNames: genUrl('/stat/social/wechat/officialAccount/fetchAllOfficialAccountName', '获取已接入ICC系统的微信公众号名称'),

  fetchFansIndexStatisticsData: genUrl('/stat/social/wechat/fans/fetchFansIndexStatisticsData', '获取粉丝统计指标数据'),
  fetchFansIndexStatisticsDataTrend: genUrl('/stat/social/wechat/fans/fetchFansIndexStatisticsDataTrend', '获取粉丝统计指标数据趋势'),
  fetchFansSubscribeSourceData: genUrl('/stat/social/wechat/fans/fetchFansSubscribeSourceData', '获取粉丝来源分布数据'),
  fetchFansSexDistributionData: genUrl('/stat/social/wechat/fans/fetchFansSexDistributionData', '获取粉丝性别分布数据'),
  fetchFansAreaDistributionData: genUrl('/stat/social/wechat/fans/fetchFansAreaDistributionData', '获取粉丝区域分布数据'),

  // 社交运营分析-抖音模块
  tiktokOfficialAccountStatList: genUrl('/stat/social/tiktok/officialAccount/list', '获取已接入ICC系统的抖音公众号列表'),
  officialAccountTikTokNums: genUrl('/stat/social/tiktok/officialAccount/fetchAllTikTokNum', '获取已接入ICC系统的微信公众号名称'),

  fetchTikTokFansIndexStatData: genUrl('/stat/social/tiktok/fans/fetchTikTokFansIndexStatData', '获取抖音粉丝分析模块指标统计数据'),
  fetchTikTokFansIndexStatDataTrend: genUrl('/stat/social/tiktok/fans/fetchTikTokFansIndexStatDataTrend', '获取抖音粉丝分析模块数据趋势'),
  fetchTikTokFansPortraitData: genUrl('/stat/social/tiktok/fans/fetchTikTokFansPortraitData', '获取抖音粉丝分析模块画像数据'),

  fetchTikTokVideoIndexStatData: genUrl('/stat/social/tiktok/video/fetchTikTokVideoIndexStatData', '获取抖音视频分析模块指标统计数据'),
  fetchTikTokVideoIndexStatDataTrend: genUrl('/stat/social/tiktok/video/fetchTikTokVideoIndexStatDataTrend', '获取抖音视频分析模块数据趋势'),
  fetchTikTokVideoReleaseFrequency: genUrl('/stat/social/tiktok/video/fetchTikTokVideoReleaseFrequency', '获取抖音视频分析模块视频发布频率'),
  fetchTikTokVideoStatisticData: genUrl('/stat/social/tiktok/video/fetchTikTokVideoStatisticData', '获取抖音视频分析模块视频统计'),

  getPreviewData: genUrl('/stat/report/getPreviewData', '报表模块数据查询'),

  // app 应用
  appWechatCustomer: genUrl('/app/wechat/customer', '根据openId获取客户'),
  appWechatCustomerTags: genUrl('/app/wechat/customer/getCustomerTag', '根据openId获取客户标签'),
  appWechatCustomerPhone: genUrl('/app/wechat/customer/phone', '远程校验手机号唯一性'),
  appWechatCustomerAdd: genUrl('/app/wechat/customer/add', '从微信端新增客户'),
  appWechatCustomerUpdate: genUrl('/app/wechat/customer/update', '从微信端更新客户'),

  // 导入导出管理
  importExportList: genUrl('/system/import-export/list', '导入导出管理获取表格数据'),
  importExportDownload: genUrl('/system/import-export/download', '导入导出管理下载文件'),
  // 频次管控
  frequencyAllUser: genUrl('/sendconstraint/frequency/users', '获取所有用户'),
  frequencyList: genUrl('/sendconstraint/frequency/list', '频次管控列表'),
  frequencyGet: genUrl('/sendconstraint/frequency/get', '频次管控详情'),
  frequencyUpdate: genUrl('/sendconstraint/frequency/update', '频次管控修改'),
  frequencyBatchUpdate: genUrl('/sendconstraint/frequency/batchUpdate', '批量频次管控更新'),
  frequencyStateUpdate: genUrl('/sendconstraint/frequency/updateState', '频次管控状态更新'),
  frequencyRecover: genUrl('/sendconstraint/frequency/recover', '频次管控数据恢复'),

  // 黑名单管理
  // 消息类型统计
  blacklistAllUsers: genUrl('/sendconstraint/blacklist/users', '查询所有用户'),
  blacklistAllChannels: genUrl('/sendconstraint/blacklist/channels', '查询所有渠道'),
  blacklistAllBizTypes: genUrl('/sendconstraint/blacklistBizTypes', '查询所有业务类型'),

  smsBlacklist: genUrl('/sendconstraint/blacklist/list/0', '获取短信黑名单列表'),
  smsBlacklistAdd: genUrl('/sendconstraint/blacklist/sms/add', '新增短信黑名单'),
  smsBlacklistDel: genUrl('/sendconstraint/blacklist/sms/delete', '删除短信黑名单'),
  smsBlacklistImport: genUrl('/sendconstraint/blacklist/sms/import/handle', '导入短信黑名单'),
  smsBlacklistUploadPercent: genUrl('/sendconstraint/blacklist/sms/import/uploadState', '上传短信黑名单进度查看'),
  smsBlacklistExport: genUrl('/sendconstraint/blacklist/sms/export', '导出短信黑名单'),
  smsBlacklistBizType: genUrl('/sendconstraint/blacklist/bizType/0/0', '获取短信业务类型'),
  smsBlacklistAllBizType: genUrl('/sendconstraint/blacklist/bizType/0/1', '获取所有短信业务类型'),
  smsBlacklistChannel: genUrl('/sendconstraint/blacklist/channel/0', '获取短信渠道'),

  voiceBlacklist: genUrl('/sendconstraint/blacklist/list/3', '获取语音黑名单列表'),
  voiceBlacklistAdd: genUrl('/sendconstraint/blacklist/voice/add', '新增语音黑名单'),
  voiceBlacklistDel: genUrl('/sendconstraint/blacklist/voice/delete', '删除语音黑名单'),
  voiceBlacklistImport: genUrl('/sendconstraint/blacklist/voice/import/handle', '导入语音黑名单'),
  voiceBlacklistUploadPercent: genUrl('/sendconstraint/blacklist/voice/import/uploadState', '上传语音黑名单进度查看'),
  voiceBlacklistExport: genUrl('/sendconstraint/blacklist/voice/export', '导出语音黑名单'),
  voiceBlacklistBizType: genUrl('/sendconstraint/blacklist/bizType/3/0', '获取语音业务类型'),
  voiceBlacklistAllBizType: genUrl('/sendconstraint/blacklist/bizType/3/1', '获取所有语音业务类型'),
  voiceBlacklistChannel: genUrl('/sendconstraint/blacklist/channel/3', '获取语音渠道'),

  wechatBlacklist: genUrl('/sendconstraint/blacklist/list/2', '获取微信黑名单列表'),
  wechatBlacklistAdd: genUrl('/sendconstraint/blacklist/wechat/add', '新增微信黑名单'),
  wechatBlacklistDel: genUrl('/sendconstraint/blacklist/wechat/delete', '删除微信黑名单'),
  wechatBlacklistExport: genUrl('/sendconstraint/blacklist/wechat/export', '导出微信黑名单'),
  wechatBlacklistOfficialAccount: genUrl('/sendconstraint/blacklist/officialAccount/list', '查询公众号列表'),
  wechatBlacklistOfficialAccountFans: genUrl('/sendconstraint/blacklist/officialAccount/fans', '查询公众号粉丝列表'),
  wechatBlacklistBizType: genUrl('/sendconstraint/blacklist/bizType/2/0', '获取微信业务类型'),
  wechatBlacklistAllBizType: genUrl('/sendconstraint/blacklist/bizType/2/1', '获取所有微信业务类型'),

  emailBlacklist: genUrl('/sendconstraint/blacklist/list/4', '获取邮件黑名单列表'),
  emailBlacklistAdd: genUrl('/sendconstraint/blacklist/email/add', '新增邮件黑名单'),
  emailBlacklistDel: genUrl('/sendconstraint/blacklist/email/delete', '删除微信黑名单'),
  emailBlacklistImport: genUrl('/sendconstraint/blacklist/email/import/handle', '导入邮件黑名单'),
  emailBlacklistUploadPercent: genUrl('/sendconstraint/blacklist/email/import/uploadState', '上传邮件黑名单进度查看'),
  emailBlacklistExport: genUrl('/sendconstraint/blacklist/email/export', '导出邮件黑名单'),
  emailBlacklistBizType: genUrl('/sendconstraint/blacklist/bizType/4/0', '获取邮件业务类型'),
  emailBlacklistAllBizType: genUrl('/sendconstraint/blacklist/bizType/4/1', '获取所有邮件业务类型'),
  emailBlacklistChannel: genUrl('/sendconstraint/blacklist/channel/4', '获取邮件渠道'),

  g5Blacklist: genUrl('/sendconstraint/blacklist/list/9', '获取5G黑名单列表'),
  g5BlacklistAdd: genUrl('/sendconstraint/blacklist/5g/add', '新增5G黑名单'),
  g5BlacklistDel: genUrl('/sendconstraint/blacklist/5g/delete', '删除5G黑名单'),
  g5BlacklistImport: genUrl('/sendconstraint/blacklist/5g/import/handle', '导入5G黑名单'),
  g5BlacklistUploadPercent: genUrl('/sendconstraint/blacklist/5g/import/uploadState', '上传5G黑名单进度查看'),
  g5BlacklistExport: genUrl('/sendconstraint/blacklist/5g/export', '导出5G黑名单'),
  g5BlacklistBizType: genUrl('/sendconstraint/blacklist/bizType/9/0', '获取5G业务类型'),
  g5BlacklistAllBizType: genUrl('/sendconstraint/blacklist/bizType/9/1', '获取所有5G业务类型'),
  g5BlacklistChannel: genUrl('/sendconstraint/blacklist/channel/9', '获取5G渠道'),

  // 企业微信
  workwxBlacklist: genUrl('/sendconstraint/blacklist/list/8', '获取企业微信黑名单列表'),
  workwxBlacklistAdd: genUrl('/sendconstraint/blacklist/workwx/add', '新增企业微信黑名单'),
  workwxBlacklistDel: genUrl('/sendconstraint/blacklist/workwx/delete', '删除企业微信黑名单'),
  workwxBlacklistExport: genUrl('/sendconstraint/blacklist/workwx/export', '导出企业微信黑名单'),
  workwxBlacklistDept: genUrl('/sendconstraint/blacklist/workwxAccount/deptList', '获取企业微信部门列表'),
  workwxBlacklistUser: genUrl('/sendconstraint/blacklist/workwxAccount/userList', '获取企业微信员工列表'),
  workwxBlacklistBizType: genUrl('/sendconstraint/blacklist/bizType/8/0', '获取企业微信业务类型'),
  workwxBlacklistAllBizType: genUrl('/sendconstraint/blacklist/bizType/8/1', '获取企业微信业务类型'),

  // 极光推送
  jpushBlacklist: genUrl('/sendconstraint/blacklist/list/6', '查询极光推送黑名单列表'),
  jpushBlacklistAdd: genUrl('/sendconstraint/blacklist/jpush/add', '新增极光推送黑名单'),
  jpushBlacklistDel: genUrl('/sendconstraint/blacklist/jpush/delete', '删除极光推送黑名单'),
  jpushBlacklistImport: genUrl('/sendconstraint/blacklist/jpush/import/handle', '导入极光黑名单'),
  jpushBlacklistUploadPercent: genUrl('/sendconstraint/blacklist/jpush/import/uploadState', '上传极光黑名单进度查看'),
  jpushBlacklistExport: genUrl('/sendconstraint/blacklist/jpush/export', '导出极光黑名单'),
  jpushBlacklistBizType: genUrl('/sendconstraint/blacklist/bizType/6/0', '获取极光业务类型'),
  jpushBlacklistAllBizType: genUrl('/sendconstraint/blacklist/bizType/6/1', '获取所有极光业务类型'),

  // 敏感字管控
  keywordAllUsers: genUrl('/sendconstraint/keyword/users', '查询所有用户'),
  keywordAllBizs: genUrl('/sendconstraint/keyword/bizs/', '查询所有业务类型'),
  keywordAllChannels: genUrl('/sendconstraint/keyword/channels/', '查询所有渠道'),
  keywordList: genUrl('/sendconstraint/keyword/list', '获取敏感字列表'),
  keywordAdd: genUrl('/sendconstraint/keyword/add', '新增敏感字'),
  keywordEdit: genUrl('/sendconstraint/keyword/edit', '编辑敏感字'),
  keywordDel: genUrl('/sendconstraint/keyword/delete', '删除敏感字'),
  keywordImport: genUrl('/sendconstraint/keyword/import/handle', '导入敏感字'),
  workwxKeywordImport: genUrl('/sendconstraint/keyword/import/handle/8', '企业微信导入敏感字'),
  keywordUploadPercent: genUrl('/sendconstraint/keyword/import/uploadState', '上传敏感字进度查看'),
  keywordExport: genUrl('/sendconstraint/keyword/export', '导出敏感字'),

  // wechatMenu url
  wechatMenu: genUrl('/system/wechatMenu/list', '微信菜单管理列表'),
  wechatMenuAdd: genUrl('/system/wechatMenu/add', '微信菜单新增'),
  wechatMenuEdit: genUrl('/system/wechatMenu/edit', '微信菜单编辑'),
  wechatMenuDelete: genUrl('/system/wechatMenu/delete', '微信菜单删除'),
  wechatMenuBatchDelete: genUrl('/system/wechatMenu/delete', '微信菜单批量删除'),
  wechatMenuDetail: genUrl('/system/wechatMenu/detail', '微信菜单详情'),
  wechatMenuChannelInfo: genUrl('/system/wechatMenu/channelInfo', '获取渠道信息'),
  wechatMenuTagMeta: genUrl('/system/wechatMenu/tagMeta', '获取标签信息'),
  wechatMenuCustomerGroup: genUrl('/system/wechatMenu/customerGroup', '获取客户分组信息'),
  wechatMenuParentName: genUrl('/system/wechatMenu/parentName', '获取一级分组信息'),
  wechatMenuCheckName: genUrl('/system/wechatMenu/checkName', '远程校验'),
  wechatMenuUpdateParentName: genUrl('/system/wechatMenu/updateParentName', '更新上级菜单'),
  // wechatMenu end

  // marketing-patch start
  patchAdd: genUrl('/business/patch/add', '新增营销贴片'),
  patchEdit: genUrl('/business/patch/edit', '编辑营销贴片'),
  patchList: genUrl('/business/patch/list', '营销贴片列表'),
  patchDetail: genUrl('/business/patch/detail', '营销贴片详情'),
  patchActive: genUrl('/business/patch/active', '营销贴片启停'),
  patchDelete: genUrl('/business/patch/delete', '营销贴片删除'),
  patchMediaUpload: genUrl('/business/patch/media/upload', '图片上传'),
  patchDeleteItemCheck: genUrl('/business/patch/deleteItem/check', '检查是否可以删除贴片项'),
  patchCheckName: genUrl('/business/patch/checkPatchName', '检查贴片名称唯一性'),
  // marketing-patch end

  // patch-audit start
  patchAuditList: genUrl('/business/patchAudit/list', '营销贴片列表'),
  patchAuditAudit: genUrl('/business/patchAudit/audit', '营销贴片列表'),
  patchAuditDetail: genUrl('/business/patchAudit/detail', '营销贴片列表'),
  patchAuditAudited: genUrl('/business/patchAudit/audited', '营销贴片审核记录'),
  // patch-audit end

  // chatbot-audit start
  chatbotAuditList: genUrl('/business/chatBotMenuAudit/audit/list', 'ChatBot待审核列表'),
  chatbotAuditDetail: genUrl('/business/chatBotMenuAudit/audit/detail', 'ChatBot待审核记录详情'),
  chatbotAuditCheck: genUrl('/business/chatBotMenuAudit/audit/auditOperate', 'ChatBot提交审核'),
  chatbotAuditedList: genUrl('/business/chatBotMenuAudit/audited/list', 'ChatBot审核记录列表'),
  // chatbot-audit end

  // chatBotInformation-audit start
  chatBotInformationWaitAuditList: genUrl('/business/chatBotInformationAudit/audit/list', 'ChatBot基本信息待审核列表'),
  chatBotInformationWaitAuditDetail: genUrl('/business/chatBotInformationAudit/audit/detail', 'ChatBot基本信息待审核详情'),
  chatBotInformationAuditedList: genUrl('/business/chatBotInformationAudit/audited/list', 'ChatBot基本信息审核记录列表'),
  chatBotInformationAuditCheck: genUrl('/business/chatBotInformationAudit/audit/check', 'ChatBot基本信息审核操作'),

  // chatBotInformation-audit end

  // #region wechat social analysis
  // Article
  fetchArticleIndexStatistics: genUrl('/stat/social/wechat/article/fetchIndexStatistics', '图文指标统计'),
  fetchArticleDataTrend: genUrl('/stat/social/wechat/article/fetchDataTrend', '图文数据趋势'),
  fetchArticleSourceDistribution: genUrl('/stat/social/wechat/article/fetchSourceDistribution', '图文来源分析'),
  fetchArticlePublishingFrequency: genUrl('/stat/social/wechat/article/fetchArticlePublishingFrequency', '文章发布频率'),
  fetchArticleShareInversion: genUrl('/stat/social/wechat/article/fetchArticleShareInversion', '图文分享转化'),
  fetchArticle: genUrl('/stat/social/wechat/article/fetchArticle', '图文列表'),

  // leavingMessage
  fetchLeavingMessageDataTrend: genUrl('/stat/social/wechat/leavingMessage/fetchDataTrend', '留言数据趋势'),
  fetchLeavingMessageDistribution: genUrl('/stat/social/wechat/leavingMessage/fetchLeavingMessageDistribution', '留言分布'),
  fetchLeavingMessage: genUrl('/stat/social/wechat/leavingMessage/fetchLeavingMessage', '留言列表'),
  // #endregion

  // #region 公告
  systemNoticeList: genUrl('/system/notice/list', '查询公告管理列表'),
  systemNoticeAdd: genUrl('/system/notice/publish', '发布公告'),
  systemNoticeDel: genUrl('/system/notice/delete', '删除公告'),
  // #endregion

  // #region 运营商号段
  carrierSegList: genUrl('/information/carrierSeg/list', '查询号段列表'),
  carrierSegAdd: genUrl('/information/carrierSeg/add', '新增号段'),
  carrierSegDel: genUrl('/information/carrierSeg/del', '删除号段'),
  carrierSegBatchDel: genUrl('/information/carrierSeg/batchDel', '删除号段'),
  carrierSegUpdate: genUrl('/information/carrierSeg/update', '修改号段'),
  // #endregion

  // channel switch config start
  channelAutoSwitch: genUrl('/information/channelChange/channelAutoSwitch/list', '自动切换配置列表'),
  channelAutoSwitchAdd: genUrl('/information/channelChange/channelAutoSwitch/add', '自动切换配置新增'),
  channelAutoSwitchEdit: genUrl('/information/channelChange/channelAutoSwitch/edit', '自动切换配置编辑'),
  channelAutoSwitchDelete: genUrl('/information/channelChange/channelAutoSwitch/delete', '自动切换配置删除'),
  channelAutoSwitchBatchDelete: genUrl('/information/channelChange/channelAutoSwitch/delete', '自动切换配置批量删除'),
  channelAutoSwitchActive: genUrl('/information/channelChange/channelAutoSwitch/active', '自动切换配置启停'),
  channelAutoSwitchDetail: genUrl('/information/channelChange/channelAutoSwitch/detail', '自动切换配置详情'),
  channelAutoSwitchChannelInfo: genUrl('/information/channelChange/channelAutoSwitch/channelInfo', '获取渠道信息'),
  channelAutoSwitchManualSwitch: genUrl('/information/channelChange/channelAutoSwitch/manualSwitch', '手动切换渠道'),
  channelAutoSwitchCheckChannelAvailable: genUrl('/information/channelChange/channelAutoSwitch/checkChannelAvailable', '检测要切换的渠道状态'),

  channelSwitchHistory: genUrl('/information/channelChange/channelSwitchHistory/list', '切换历史列表'),
  // channel  switch config end
  // start report stat 柳行同步过来的报表
  deptReportStat: genUrl('/reportStat/dept/list', '部门统计列表查询'),
  deptReportStatExport: genUrl('/reportStat/dept/export', '部门统计导出'),
  deptReportStatGetDeptList: genUrl('/reportStat/dept/department/list', '部门列表查询'),
  deptReportStatTrend: genUrl('/reportStat/dept/trend', '部门统计图表查询'),

  userReportStat: genUrl('/reportStat/user/list', '用户统计列表查询'),
  userReportStatExport: genUrl('/reportStat/user/export', '用户统计导出'),
  userReportStatGetUserList: genUrl('/reportStat/user/userList', '用户列表查询'),
  userReportStatTrend: genUrl('/reportStat/user/trend', '用户统计图表查询'),

  channelReportStat: genUrl('/reportStat/channel/list', '渠道统计列表查询'),
  channelReportStatExport: genUrl('/reportStat/channel/export', '渠道统计导出'),
  channelReportStatTrend: genUrl('/reportStat/channel/trend', '渠道统计图表查询'),

  bizTypeReportIndexStat: genUrl('/reportStat/bizType/index/list', '业务类型统计列表查询'),
  bizTypeReportStat: genUrl('/reportStat/bizType/list', '业务类型统计趋势列表查询'),
  bizTypeReportStatExport: genUrl('/reportStat/bizType/export', '业务类型统计趋势导出'),
  bizTypeReportStatTrend: genUrl('/reportStat/bizType/trend', '业务类型统计图表查询'),
  bizTypeReportStatBizs: genUrl('/reportStat/bizType/bizs', '业务类型获取'),
  bizTypeReportStatSingleType: genUrl('/reportStat/bizType/singleType', '业务类型单个消息类型统计'),

  costAccountingReportStat: genUrl('/reportStat/costAccounting/list', '成本核算列表查询'),
  costAccountingReportStatExport: genUrl('/reportStat/costAccounting/export', '成本核算导出'),
  costAccountingReportStatTrend: genUrl('/reportStat/costAccounting/trend', '成本核算图表查询'),
  // end report stat

  // 5g url about --start
  g5StatiscticSummaryUrl: genUrl('/5g/shorturl/slstatistic/summary', '5G短链统计-列表查询'),
  g5StatiscticDetailUrl: genUrl('/5g/shorturl/slstatistic/detail', '5G短链统计-统计详情'),
  g5StatiscticSlVisitUrl: genUrl('/5g/shorturl/slstatistic/slVisit', '5G短链统计-链接访问分析'),
  g5StatiscticPhoneUrl: genUrl('/5g/shorturl/slstatistic/phoneVisit', '5G短链统计-号码访问分析'),
  g5StatiscticAreaUrl: genUrl('/5g/shorturl/slstatistic/areaVisit', '5G短链统计-地域维度访问分析'),
  g5GetProvinceTableList: genUrl('/5g/shorturl/slstatistic/getProvinceTableList', '5G短链统计-获取该省份地市数据'),
  g5StatiscticDeviceUrl: genUrl('/5g/shorturl/slstatistic/deviceVisit', '5G短链统计-终端维度访问分析'),
  g5StatiscticTableUrl: genUrl('/5g/shorturl/slstatistic/visitDetail', '5G短链统计-数据详情表格共用'),
  g5StatiscticTableExport: genUrl('/5g/shorturl/slstatistic/export', '5G短链统计-数据详情导出'),
  // 5g url about --end

  // long url about --start
  // longUrlStatiscticTableUrl: genUrl('/longurl/slstatistic/visitDetail', '长链统计-数据详情表格共用'),
  longUrlStatiscticTableExport: genUrl('/longurl/slstatistic/detailExport', '长链统计-数据详情导出'),
  longUrlStatSummary: genUrl('/longurl/slstatistic/summary', '长链统计列表'),
  longUrlStatTrend: genUrl('/longurl/slstatistic/trend', '长链统计-访问趋势'),
  longUrlStatArea: genUrl('/longurl/slstatistic/map', '长链统计-访问地区'),
  longUrStatlOs: genUrl('/longurl/slstatistic/os', '长链统计-发送设备'),
  longUrlStatMsgType: genUrl('/longurl/slstatistic/statMsgType', '长链他统计-消息类型访问统计'),
  longUrlTop5ShortUrl: genUrl('/longurl/slstatistic/top5ShortUrl', '长链统计-短链访问Top5统计'),
  longUrlDataStat: genUrl('/longurl/slstatistic/dataStat', '长链统计-数据统计'),
  longUrlSendDataStat: genUrl('/longurl/slstatistic/sendDataStat', '长链统计-发送数据统计'),
  // longUrlStatBrowser: genUrl('/longurl/slstatistic/browser', '长链统计-浏览器'),
  longUrlStatDetail: genUrl('/longurl/slstatistic/detail2sms', '长链统计-数据详情'),
  longUrlStatDetailExport: genUrl('/longurl/slstatistic/detailExport', '长链统计-数据详情导出'),
  longUrlGetProvinceTableList: genUrl('/longurl/slstatistic/getProvinceTableList', '长链统计-获取该省份地市数据'),
  // long url about --end

  // short url about --start
  targeturlPage: genUrl('/shorturl/targeturl/list', '长链接管理列表'), // Todo:duplicated
  targeturlDelete: genUrl('/shorturl/targeturl/delete', '长链接-删除'),
  targeturlAdd: genUrl('/shorturl/targeturl/add', '长链接-新增'),

  batchNamesUrl: genUrl('/shorturl/slstatistic/batchNames', '短链统计-获取批次名称'),
  slStatiscticSummaryUrl: genUrl('/shorturl/slstatistic/summary', '短链统计-概览'),
  slStatiscticSendDataUrl: genUrl('/shorturl/slstatistic/sendData', '短链统计-发送数据'),
  slStatiscticOsUrl: genUrl('/shorturl/slstatistic/os', '短链统计-设备系统'),
  slStatiscticDataStat: genUrl('/shorturl/slstatistic/dataStat', '短链统计-数据统计'),
  slStatiscticTrendUrl: genUrl('/shorturl/slstatistic/trend', '短链统计-访问趋势'),
  slStatiscticBrowserUrl: genUrl('/shorturl/slstatistic/browser', '短链统计-浏览器'),
  slStatiscticMapUrl: genUrl('/shorturl/slstatistic/map', '短链统计-地图'),
  shortUrlGetProvinceTableList: genUrl('/shorturl/slstatistic/getProvinceTableList', '短链统计-获取该省份地市数据'),
  slStatiscticDetailListUrl: genUrl('/shorturl/slstatistic/detail2sms', '短链统计-采集信息明细'),
  shortUrlStatiscticTableExport: genUrl('/shorturl/slstatistic/detailExport', '短链统计-数据详情导出'),

  loadTargetUrlAuditDetailUrl: genUrl('/shorturl/targeturlAudit/audit/detail', '长链接审批-审批数据明细'),
  loadTargetUrlAuditCheckUrl: genUrl('/shorturl/targeturlAudit/audit/check', '长链接审批-审批操作'),
  targeturlAuditedListUrl: genUrl('/shorturl/targeturlAudit/audited', '长链接审批-获取已审批数据'),
  loadWxAppAuditCheckUrl: genUrl('/shorturl/wxapp/audit/check', '小程序链接审批-审批操作'),

  domainPage: genUrl('/shorturl/domains/list', '长链接管理列表'),
  domainDelete: genUrl('/shorturl/domains/delete', '长链接-删除'),
  domainAdd: genUrl('/shorturl/domains/add', '长链接-新增'),

  getAllProvince: genUrl('/common/getAllProvince', '获取所有省份'),
  getAllCities: genUrl('/common/getAllCities', '获取所有城市'),

  // short url about --end

  // wxapp/applet url -- start
  appletPage: genUrl('/shorturl/wxapp/list', '微信小程序链接管理-列表查询'),
  appletAdd: genUrl('/shorturl/wxapp/add', '微信小程序链接管理-添加链接'),
  appletModify: genUrl('/shorturl/wxapp/modify', '微信小程序链接管理-修改链接'),
  appletReplicate: genUrl('/shorturl/wxapp/replicate', '微信小程序链接管理-复制链接'),
  appletDelete: genUrl('/shorturl/wxapp/delete', '微信小程序链接管理-链接删除'),
  validateLinkName: genUrl('/shorturl/wxapp/nameExist', '微信小程序链接管理-链接名称校验'),
  // wxapp/applet url -- end

  getMessageUUID: genUrl('/common/getId', '从后端获取UUID，发送中心使用'),
};
export function getUrlName(url: string) {
  if (url) {
    for (let item in URLS) {
      /*IE不支持inclueds*/
      // if (url.includes(URLS[item].url)) {
      if (url.indexOf(URLS[item].url) !== -1) {
        return URLS[item].name;
      }
    }
  }
  return url;
}
